import React from "react";
import { NavigateFunction} from "react-router-dom";
import {
  Button,
  Form,
  Container,
  Divider,
  Header,
  Grid,
  GridRow,
  GridColumn,
  Ref,
  Sticky,
  Table, Image
} from "semantic-ui-react";
import { connect } from "react-redux";
import { Policy } from "../../models/policy.model";
import { IStoreState } from "../../redux/reducers/root.reducer";
import { policyActions } from "../../redux/actions/policy.actions";
import { IPaymentResponse } from "../../models/payment-response.interface";
import { paymentActions } from "../../redux/actions/payment.actions";
import { Basket } from "../../models/basket.model";
import { IPolicyResponse } from "../../models/policy-response.interface";
import { IUtm } from "../../models/utm.interface";
import Wizard from "../Wizard/Wizard";
import { validation } from "../../util/validation";
import ErrorMessage from "../Validators/ErrorMessage";
import OrderSummary from "../OrderSummary/OrderSummary";

import {DisplayMode, EditMode} from "../AddressSelector/AddressSelector";
import AddressSelector from "../AddressSelector/AddressSelector";
import {Address} from "../AddressSelector/Address"
import {Country} from "../CountrySelector/Country";

import {addressLookupURL} from "../../index";
import SecurePaymentLogos from "../../resources/images/Secure-pay-logo.jpg";

enum companyOrIndividualType
{
  unknown = 0,
  company = 1,
  individual = 2
}
interface IProps {
  email: string;
  phone:string;
  basket: Basket;
  startDate: string;
  policyResponse: IPolicyResponse | null;
  paymentResponse: IPaymentResponse | null;
  finalisePolicy(id: number | null, policy: Policy, utm: IUtm): void;
  clear(): void;
  utm: IUtm | null;
  navigate:NavigateFunction;
}

interface IState {
  policy: Policy;
  policyId: number;
  isPaymentInProgress: boolean;
  showCompanyNameMinLengthError: boolean;
  showCompanyNameError: boolean;
  showCompanyOrIndividualError:boolean;
  companyNameDirty: boolean;
  showFirstNameMinLengthError: boolean;
  showFirstNameError: boolean;
  firstNameDirty: boolean;
  showLastNameMinLengthError: boolean;
  showLastNameError: boolean;
  lastNameDirty: boolean;
  showEmailEmptyError: boolean;
  showInvalidEmailError: boolean;
  showEmailError: boolean;
  emailDirty: boolean;
  showPhoneCountryCodeEmptyError: boolean;
  showInvalidPhoneCountryCodeError: boolean;
  showPhoneCountryCodeError: boolean;
  phoneCountryCodeDirty: boolean;
  showPhoneEmptyError: boolean;
  showInvalidPhoneError: boolean;
  showPhoneError: boolean;
  phoneDirty: boolean;
  showTitleError: boolean;
  isValid: boolean;
  hideCheckout: boolean;
  paying: boolean;
  failed: boolean;
  companyOrIndividual:companyOrIndividualType;
  currentlySelectedCountry:string;
  currentlySelectedCountry2CharIsoCode:string;
  showDebug:boolean;
}

export class _Checkout extends React.Component<IProps, IState> {
  state: IState = {
    policy: new Policy(),
    policyId:0,
    isPaymentInProgress: false,
    showCompanyNameMinLengthError: false,
    showCompanyOrIndividualError:false,
    showCompanyNameError: false,
    companyNameDirty: false,
    showFirstNameMinLengthError: false,
    showFirstNameError: false,
    firstNameDirty: false,
    showLastNameMinLengthError: false,
    showLastNameError: false,
    lastNameDirty: false,
    showEmailEmptyError: false,
    showInvalidEmailError: false,
    showEmailError: false,
    emailDirty: false,
    showPhoneCountryCodeEmptyError: false,
    showInvalidPhoneCountryCodeError: false,
    showPhoneCountryCodeError: false,
    phoneCountryCodeDirty: false,
    showPhoneEmptyError: false,
    showInvalidPhoneError: false,
    showPhoneError: false,
    phoneDirty: false,
    showTitleError: false,
    isValid: false,
    hideCheckout: false,
    paying: false,
    failed: false,
    companyOrIndividual:companyOrIndividualType.unknown,
    currentlySelectedCountry:"United Kingdom",
    currentlySelectedCountry2CharIsoCode:"GB",
    showDebug:false
  };

  constructor(props: IProps) {
    super(props);

    this.state.policy.email = this.props.email ? this.props.email : "";
    this.state.policy.phone = this.props.phone ? this.props.phone : "";

    this.state.policy.phoneCountryCode = "44";


    this.state.policyId = this.props.policyResponse?.id ?? 0;
    if (this.state.showDebug) {
      console.log("Checkout props", this.props);
      console.log("Checkout state", this.state);
    }
  }
  addressSelectorRef = React.createRef<AddressSelector>();
  stickyRef = React.createRef<HTMLElement>();

  getSnapshotBeforeUpdate(prevProps: IProps, prevState: IState) {
    return null;
  }

  componentDidUpdate(prevProps: IProps, prevState: IState, snapshot: any) {

    if (this.props.policyResponse === null) return;

    let policyId = this.state.policyId;


    /* If policy was created we have an id, if we have an id, call the initializePayment api */

    if (policyId > 0 && this.props.paymentResponse && this.props.paymentResponse.url && this.props.paymentResponse.url !== '') {

      const url = this.props.paymentResponse.url;
      this.props.clear();

      window.location.replace(url);
      //alert(url.substring(0,20));

      return;
    }

    if (policyId > 0 && this.props.paymentResponse && prevProps.paymentResponse && this.props.paymentResponse.failed !== prevProps.paymentResponse.failed) {
      //console.log("initiating payment failed");
      this.setState({paying: true, isPaymentInProgress: false, failed: true});
    }

    if (this.props.policyResponse != null && prevProps.policyResponse != null && this.props.policyResponse.failed && this.props.policyResponse.failed !== prevProps.policyResponse.failed) {
     // console.log("policy creation failed")
      this.setState({paying: false, isPaymentInProgress: false, failed: true});
    }

    /*if (policyId > 0 && this.state.isValid && (!this.props.paymentResponse || this.props.paymentResponse.url == null) 
      && !this.state.paying) {
      
        console.log("Initiating payment");
        this.setState({paying: true, failed: false}, () => this.props.initiatePayment(policyId));
      
    }*/
  }

  onAddressSelect = (address: Address) => {
    this.setState(
        {
          policy: {
            ...this.state.policy,
            address: address
          },
        },
        () => this.isValidForm()
    );
  };

  onAddressReset = () => {
    this.setState({
      isValid: false,
    });
  };

  validateAddress = (): boolean => {
    if (!this.addressSelectorRef.current) return true;
    
    return this.addressSelectorRef.current.validate();
  };

  isValidForm = (): boolean => {
    let isValid = true;
    let isAddressValid = true;

    const stateCopy = { ...this.state };
    if (this.state.companyOrIndividual == companyOrIndividualType.unknown)
    {
      if (this.state.showDebug) console.log("Checkout::Validate():Individual or Company failed");

      isValid = false;
      stateCopy.showCompanyOrIndividualError = true;
    }

    if ((!validation.isEmpty(this.state.policy.companyName) && (this.state.policy.companyName.trim().length < 2 || this.state.policy.companyName.trim().length > 50)) && this.state.companyNameDirty) {
      stateCopy.showCompanyNameError = true;
      if (this.state.showDebug) console.log("Checkout::Validate():Company failed to validate");
      isValid = false;
    } else {
      stateCopy.showCompanyNameError = false;
    }
    
    if ((validation.isEmpty(this.state.policy.firstName) || this.state.policy.firstName.trim().length < 2) && this.state.firstNameDirty) {
      stateCopy.showFirstNameError = true;
      if (this.state.showDebug) console.log("Checkout::Validate():First name failed to validate");
      isValid = false;
    } else {
      stateCopy.showFirstNameError = false;
    }

    if ((validation.isEmpty(this.state.policy.lastName) || this.state.policy.lastName.trim().length < 2) && this.state.lastNameDirty) {
      stateCopy.showLastNameError = true;
      if (this.state.showDebug) console.log("Checkout::Validate():Last name failed to validate");
      isValid = false;
    } else {
      stateCopy.showLastNameError = false;
    }

    if (this.state.showDebug) console.log("Checkout::Validate():Validating address..");
    
    if (this.addressSelectorRef.current != null)
    {
      if (!this.validateAddress()) {
        if (this.state.showDebug) console.log("Checkout::Validate():Found address selector reference, but address is invalid");
        isValid = false;
        isAddressValid = false;
      }  
      else
      {
        if (this.state.showDebug) console.log("Checkout::Validate():Found address selector reference, and address is valid");
      }
    }
    else
    {
      if (this.state.showDebug) console.log("Checkout::Validate():Could not find address selector reference");
    }
    

    if ((validation.isEmpty(this.state.policy.email) || !validation.isEmail(this.state.policy.email)) && this.state.emailDirty) {
      stateCopy.showEmailError = true;
      if (this.state.showDebug) console.log("Checkout::Validate():Email failed to validate");
      isValid = false;
    } else {
      stateCopy.showEmailError = false;
    }

    if ((validation.isEmpty(this.state.policy.phoneCountryCode) || !validation.isPhoneCountryCode(this.state.policy.phoneCountryCode) || this.state.policy.phoneCountryCode.length < 1 || this.state.policy.phoneCountryCode.length > 4) && this.state.phoneCountryCodeDirty) {
      stateCopy.showPhoneCountryCodeError = true;
      if (this.state.showDebug) console.log("Checkout::Validate():Phone country code failed to validate");
      isValid = false;
    } else {
      stateCopy.showPhoneCountryCodeError = false;
    }
    
    if ((validation.isEmpty(this.state.policy.phone) || !validation.isInternationalPhone(this.state.policy.phone) || this.state.policy.phone.length < 5 || this.state.policy.phone.length > 19) && this.state.phoneDirty) {
      stateCopy.showPhoneError = true;
      if (this.state.showDebug) console.log("Checkout::Validate():Phone number failed to validate");
      isValid = false;
    } else {
      stateCopy.showPhoneError = false;
    }

    if (!this.state.firstNameDirty || !this.state.lastNameDirty || !this.state.phoneDirty) {
      isValid = false;
      if (this.state.showDebug) console.log("Checkout::Validate():Dirty");
    }

    if (isValid) {
      stateCopy.showTitleError = false;
      if (validation.isEmpty(this.state.policy.title)) {
        isValid = false;
        if (this.state.showDebug) console.log("Checkout::Validate():Title failed to validate");
        stateCopy.showTitleError = true;
      }
    }
    if (this.state.showDebug) console.log("Checkout::Validate():isValid = " + isValid);
    if (this.state.showDebug) console.log("Checkout::Validate():isAddressValid = " + isAddressValid);
    
    isValid = isValid && isAddressValid;
        
    if (this.state.showDebug) console.log("Checkout::Validate():result = " + isValid);
    stateCopy.isValid = isValid;
    this.setState(stateCopy);
    return isValid;
  };

  preventCharacters(e: any) {
    const re = /[0-9]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }

  onStep = (step: number) => {
    if (step === 2) {
      this.props.navigate("/property-and-cover");
    }
    if (step === 1) {
      this.props.navigate("/start");
    }
  }


  render() {

    
    const correspondenceAddressProps = {
      
      
      ref:this.addressSelectorRef,
      onReset:() => {
        if (this.state.showDebug) { console.log("Address reset");}
        this.onAddressReset();
        } ,
      onAddressSelect:(a:Address) => {
        if (this.state.showDebug) {console.log("Address selected",a);}
        a.country2CharIsoCode = this.state.currentlySelectedCountry2CharIsoCode;
        a.country = this.state.currentlySelectedCountry;
        if (this.state.showDebug) {console.log("Address selected after country state fix",a);}
        this.onAddressSelect(a);
      },
      showDebug:this.state.showDebug,
      allowInternationalAddress:true,
      searchCountries:"ALL",
      baseURL:addressLookupURL,
      alwaysShowCountryList:true,
      blockedPostCodeCallback:(searchTerm: string, postCodePrefixToBlock: string, msg: string) => {
      },
      onInvalidAddress:() => {
        if (this.state.showDebug) {console.log("Address invalid");}
      },
      onValidAddress:() => {
        if (this.state.showDebug) {console.log("Address valid");}
      },
      onDisplayModeChange:(dm:DisplayMode) => {
        if (this.state.showDebug) {console.log("Display mode changed to " + DisplayMode[dm]);}
      },
      onCountryChange:(c:Country) => {
        if (this.state.showDebug) {console.log("Country changed to " + c.englishShortName);}
        this.setState({
              policy: {
                ...this.state.policy,
                phoneCountryCode: c.diallingCode,
              },
              currentlySelectedCountry:c.englishShortName,
              currentlySelectedCountry2CharIsoCode:c.alpha2Code
        }, () => { //console.log("Dialing code updated");
           });
      },
      initialDisplayMode:DisplayMode.Lookup,
      editMode:EditMode.AllowChangeToCountryAndAddress
    };
  
    
    
    return (
        <>
          <Container>
            <Wizard activeStep={3} maxActiveStep={2} onClick={this.onStep} />
            <Container className="contentWrapper">
              <Grid stackable>
                <Ref innerRef={this.stickyRef}>
                  <Grid.Row>
                    <Grid.Column mobile={16} tablet={10} computer={10}>
                      <Container className="b2c__card">
                        <Header as="h2">About you</Header>
                        <Form autoComplete="off" noValidate>
                          <Form.Field>
                            <label>Are you an Individual or a Company?</label>
                            <Grid className="clearfix titleButtons">
                              <GridRow columns={2}>
                                <GridColumn>
                                  <Button
                                      fluid
                                      onClick={(e) =>
                                          { 
                                            this.setState({
                                              policy: {
                                                ...this.state.policy,
                                                companyName: "",
                                              },
                                              showCompanyNameError: false,
                                              showCompanyNameMinLengthError: false,
                                              companyNameDirty: true,
                                              companyOrIndividual : companyOrIndividualType.individual
                                            });
                                          }}
                                      primary={this.state.companyOrIndividual === companyOrIndividualType.individual}>
                                    Individual
                                  </Button>
                                </GridColumn>
                                <GridColumn>
                                  <Button
                                      fluid
                                      onClick={(e) => this.setState({ companyOrIndividual : companyOrIndividualType.company }, () => this.isValidForm())}
                                      primary={this.state.companyOrIndividual === companyOrIndividualType.company}>
                                    Company
                                  </Button>
                                </GridColumn>
                              </GridRow>
                            </Grid>
                            <div className="companyOrIndividualError">
                              <ErrorMessage show={this.state.showCompanyOrIndividualError} message="Please indicate if you are an individual or a company" />
                            </div>
                          </Form.Field>
                          {(this.state.companyOrIndividual == companyOrIndividualType.company) && 
                          <Form.Field>
                            <label>Company name</label>
                            <Form.Input
                                type="text"
                                name="first-name"
                                maxLength={50}
                                placeholder="Your company name (if applicable)"
                                error={this.state.showCompanyNameError || this.state.showCompanyNameMinLengthError}
                                onChange={async (event: any) => {
                                  await this.setState({
                                    policy: {
                                      ...this.state.policy,
                                      companyName: event.target.value,
                                    },
                                    showCompanyNameError: false,
                                    showCompanyNameMinLengthError: false,
                                    companyNameDirty: true
                                  });
                                }}
                                onBlur={(event: any) => {
                                  if (event.target.value.length > 0) {
                                    event.target.value = event.target.value[0].toUpperCase() + event.target.value.slice(1, event.target.value.length);
                                  }
                                  this.setState(
                                      {
                                        showCompanyNameMinLengthError: this.state.policy.companyName.length > 0 && this.state.policy.companyName.trim().length < 2,
                                      },
                                      () => this.isValidForm()
                                  );
                                }}
                            />
                            <ErrorMessage show={this.state.showCompanyNameMinLengthError} message="Company name should have 2 or more letters" />
                          </Form.Field>
                          }
                          <Form.Field>
                            <label>Title</label>
                            <Grid className="clearfix titleButtons">
                              <GridRow columns={4}>
                                <GridColumn>
                                  <Button
                                      fluid
                                      onClick={(e) => this.setState({ policy: { ...this.state.policy, title: "Mr" } }, () => this.isValidForm())}
                                      primary={this.state.policy.title === "Mr"}>
                                    Mr
                                  </Button>
                                </GridColumn>
                                <GridColumn>
                                  <Button
                                      fluid
                                      onClick={(e) => this.setState({ policy: { ...this.state.policy, title: "Mrs" } }, () => this.isValidForm())}
                                      primary={this.state.policy.title === "Mrs"}>
                                    Mrs
                                  </Button>
                                </GridColumn>
                                <GridColumn>
                                  <Button
                                      fluid
                                      onClick={(e) => this.setState({ policy: { ...this.state.policy, title: "Miss" } }, () => this.isValidForm())}
                                      primary={this.state.policy.title === "Miss"}>
                                    Miss
                                  </Button>
                                </GridColumn>
                                <GridColumn>
                                  <Button
                                      fluid
                                      onClick={(e) => this.setState({ policy: { ...this.state.policy, title: "Ms" } }, () => this.isValidForm())}
                                      primary={this.state.policy.title === "Ms"}>
                                    Ms
                                  </Button>
                                </GridColumn>
                              </GridRow>
                            </Grid>
                            <div className="titleError">
                              <ErrorMessage show={this.state.showTitleError} message="Title is mandatory" />
                            </div>
                          </Form.Field>
                          <Form.Field>
                            <label>First name</label>
                            <Form.Input
                                type="text"
                                name="first-name"
                                maxLength={30}
                                placeholder="Your first name"
                                error={this.state.showFirstNameError || this.state.showFirstNameMinLengthError}
                                onChange={async (event: any) => {
                                  await this.setState({
                                    policy: {
                                      ...this.state.policy,
                                      firstName: event.target.value,
                                    },
                                    showFirstNameError: false,
                                    showFirstNameMinLengthError: false,
                                    firstNameDirty: true
                                  });
                                }}
                                onBlur={(event: any) => {
                                  if (event.target.value.length > 0) {
                                    event.target.value = event.target.value[0].toUpperCase() + event.target.value.slice(1, event.target.value.length);
                                  }
                                  this.setState(
                                      {
                                        showFirstNameMinLengthError: this.state.policy.firstName.length > 0 && this.state.policy.firstName.trim().length < 2,
                                      },
                                      () => this.isValidForm()
                                  );
                                }}
                            />
                            <ErrorMessage show={this.state.showFirstNameMinLengthError} message="First name should have 2 or more letters" />
                          </Form.Field>
                          <Form.Field>
                            <label>Last name</label>
                            <Form.Input
                                type="text"
                                name="last-name"
                                maxLength={30}
                                placeholder="Your last name"
                                error={this.state.showLastNameError || this.state.showLastNameMinLengthError}
                                onChange={async (event: any) => {
                                  await this.setState({
                                    policy: {
                                      ...this.state.policy,
                                      lastName: event.target.value,
                                    },
                                    showLastNameError: false,
                                    showLastNameMinLengthError: false,
                                    lastNameDirty: true
                                  });
                                }}
                                onBlur={(event: any) => {
                                  if (event.target.value.length > 0) {
                                    event.target.value = event.target.value[0].toUpperCase() + event.target.value.slice(1, event.target.value.length);
                                  }
                                  this.setState(
                                      {
                                        showLastNameMinLengthError: this.state.policy.lastName.length > 0 && this.state.policy.lastName.trim().length < 2,
                                      },
                                      () => this.isValidForm()
                                  );
                                }}
                            />
                            <ErrorMessage show={this.state.showLastNameMinLengthError} message="Last name should have 2 or more letters" />
                          </Form.Field>
                          <Form.Field>
                            <label>Correspondence address</label>
                            <AddressSelector {...correspondenceAddressProps} />
                          </Form.Field>
                          <Form.Field>
                            <label>Phone number</label>

                            <div className="phone-and-prefix">

                              <ErrorMessage show={this.state.showInvalidPhoneCountryCodeError} message="Please enter a valid phone prefix" />

                              <div className="phone-prefix-plus">+</div>
                              
                              <Form.Input
                                  type="text"
                                  name="telprefix"
                                  maxLength={5}
                                  inputMode="numeric"
                                  onKeyPress={(e: any) => this.preventCharacters(e)}
                                  error={this.state.showPhoneCountryCodeError || this.state.showInvalidPhoneCountryCodeError || this.state.showPhoneCountryCodeEmptyError}
                                  value={this.state.policy.phoneCountryCode}
                                  onChange={async (event: any) => {
                                    await this.setState({
                                      policy: {
                                        ...this.state.policy,
                                        phoneCountryCode: event.target.value,
                                      },
                                      showPhoneCountryCodeError: false,
                                      showInvalidPhoneCountryCodeError: false,
                                      showPhoneCountryCodeEmptyError: false,
                                      phoneCountryCodeDirty: true
                                    });
                                    if (!validation.isEmpty(this.state.policy.phoneCountryCode)) {
                                      await this.setState({
                                        showPhoneCountryCodeEmptyError: false,
                                        showInvalidPhoneCountryCodeError: !validation.isPhoneCountryCode(this.state.policy.phoneCountryCode)
                                      }, () => this.isValidForm());
                                    }
                                  }}
                                  onBlur={(event: any) => {
                                    this.setState(
                                        {
                                          showInvalidPhoneCountryCodeError: !validation.isPhoneCountryCode(this.state.policy.phoneCountryCode),
                                        },
                                        () => this.isValidForm()
                                    );
                                  }}
                                  className="has_tooltip phone-prefix"
                              />
                             
                              <Form.Input
                                  type="text"
                                  name="tel"
                                  maxLength={19}
                                  value={this.state.policy.phone}
                                  inputMode="numeric"
                                  placeholder="Your phone number"
                                  onKeyPress={(e: any) => this.preventCharacters(e)}
                                  error={this.state.showPhoneError || this.state.showInvalidPhoneError || this.state.showPhoneEmptyError}
                                  onChange={async (event: any) => {
                                    await this.setState({
                                      policy: {
                                        ...this.state.policy,
                                        phone: event.target.value,
                                      },
                                      showPhoneError: false,
                                      showInvalidPhoneError: false,
                                      showPhoneEmptyError: false,
                                      phoneDirty: true
                                    });
                                    if (!validation.isEmpty(this.state.policy.phone)) {
                                      await this.setState({
                                        showPhoneEmptyError: false,
                                        showInvalidPhoneError: !validation.isInternationalPhone(this.state.policy.phone)
                                      }, () => this.isValidForm());
                                    }
                                  }}
                                  onBlur={(event: any) => {
                                    this.setState(
                                        {
                                          showInvalidPhoneError: !validation.isInternationalPhone(this.state.policy.phone),
                                        },
                                        () => this.isValidForm()
                                    );
                                  }}
                                  className="has_tooltip phone"
                              />
                              <ErrorMessage show={this.state.showInvalidPhoneError} message="Please enter a valid phone number" />
                            </div>
                          </Form.Field>                          
                          <Form.Field>
                            <label>Email address</label>
                            <Form.Input
                                type="email"
                                name="email"
                                maxLength={50}
                                placeholder="Your email address"
                                error={this.state.showEmailError || this.state.showInvalidEmailError || this.state.showEmailEmptyError}
                                value={this.state.policy.email}
                                onChange={async (event: any) => {
                                  await this.setState({
                                    policy: {
                                      ...this.state.policy,
                                      email: event.target.value,
                                    },
                                    showEmailError: false,
                                    showInvalidEmailError: false,
                                    showEmailEmptyError: false,
                                    emailDirty: true
                                  });
                                  if (!validation.isEmpty(this.state.policy.email)) {
                                    await this.setState({ showEmailEmptyError: false });
                                  }
                                }}
                                onBlur={(event: any) => {
                                  this.setState(
                                      {
                                        showInvalidEmailError: !validation.isEmail(this.state.policy.email),
                                      },
                                      () => this.isValidForm()
                                  );
                                }}
                            />
                            <ErrorMessage show={this.state.showInvalidEmailError} message="Please enter a valid email address" />
                          </Form.Field>

                          <Divider hidden />
                          
                        </Form>
                      </Container>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={6} computer={6} className="orderSummary">
                      <Sticky context={this.stickyRef} offset={20}>
                        <OrderSummary readOnly
                                      onExpand={(isMaximized) => {if (isMaximized) {document.body.style.overflow = "hidden";} else {document.body.style.overflow = "inherit"}}}
                                      properties={this.props.basket.properties} onAddProperty={() => {}} onPropertySelect={_=>{}} onRemoveFromBasket={(a,b)=>{}}
                                      onCheckout={()=>{}}
                                      {...this.props}
                        />
                        
                         <Table basic="very" attached className="orderSummaryButtonsCheckout no-margin small-devices">
                            <Table.Body>
                              <Table.Row className="orderSummaryButtonsMobile clearfix">
                                <Table.Cell className="orderSummaryButtonsWrapper checkout">
                                  <Button
                                      loading={this.state.isPaymentInProgress}
                                      disabled={!this.state.isValid}
                                      positive
                                      size="large"
                                      className="left floated payNowButton"
                                      onClick={async (event: any) => {

                                        event.preventDefault();

                                        if (this.isValidForm()) {
                                          let policy = this.state.policy;
                                          policy.id = this.state.policyId;
                                          policy.properties = this.props.basket.properties.filter((e) => e.products);
                                          policy.agentCode = (this.props.utm || {agent: "ABIB"}).agent;
                                          policy.fromDate = this.props.startDate;

                                          // capitalize firstName, lastName and companyName if present
                                          policy.firstName = policy.firstName[0].toUpperCase() + policy.firstName.slice(1, policy.firstName.length);
                                          policy.lastName = policy.lastName[0].toUpperCase() + policy.lastName.slice(1, policy.lastName.length);

                                          if (policy.companyName.length>0)
                                          {
                                            policy.companyName = policy.companyName[0].toUpperCase() + policy.companyName.slice(1, policy.companyName.length);
                                          }
                                          if (policy.address.country == null && policy.address.country2CharIsoCode != null)
                                          {
                                            policy.address.country = policy.address.country2CharIsoCode;
                                          }
                                          if (policy.address.country2CharIsoCode != null && policy.address.country2CharIsoCode != "GB" && (policy.address.postCode == null || policy.address.postCode==""))
                                          {
                                            policy.address.postCode = "00000";
                                          }
                                          
                                          if (this.state.showDebug) {
                                            console.log("Checkout::policy", this.state.policy);
                                            console.log("Checkout::props", this.props);
                                            console.log("Checkout::state", this.state);
                                          }
                                          this.props.finalisePolicy(
                                              this.state.policyId,
                                              policy,
                                              this.props.utm == null
                                                  ? {
                                                    campaign: null,
                                                    adgroup: null,
                                                    keyword: null,
                                                    gclid: null,
                                                    fallback:null,
                                                    medium: null,
                                                    source: null,
                                                    agent: (this.props.utm || {campaign:"",content:"",medium:"",source:"",agent:"ABIB"}).agent
                                                  }
                                                  : this.props.utm
                                          );
                                          await this.setState({ isPaymentInProgress: true, failed: false });
                                        }
                                      }}>
                                    Pay Now
                                  </Button>
                                  <ErrorMessage show={this.state.failed} message="Failed to create policy" />
                                </Table.Cell>
                              </Table.Row>
                            </Table.Body>
                          </Table>
                          <Table basic="very" attached className="securePaymentLogoSection checkout">
                            <Table.Body>
                              <Table.Row>
                                <Table.Cell textAlign="right">
                                  <Image className={"securePaymentLogos"} src={SecurePaymentLogos} />
                                </Table.Cell>
                              </Table.Row>
                            </Table.Body>
                          </Table>
                    

                      </Sticky>
                    </Grid.Column>
                  </Grid.Row>
                </Ref>
              </Grid>
            </Container>
          </Container>
        </>
    );
  }
}

const mapStateToProps = ({
                           email,
                           phone,
                           startDate,
                           basket,
                           paymentResponse,
                           policyResponse,
                           utm,
                         }: IStoreState): {
  email: string;
  phone:string;
  startDate: string;
  basket: Basket;
  paymentResponse: IPaymentResponse | null;
  policyResponse: IPolicyResponse | null;
  utm: IUtm | null;
} => {
  return {
    email,
    phone,
    startDate,
    basket,
    paymentResponse,
    policyResponse,
    utm,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    finalisePolicy: (id: number | null, policy: Policy, utm: IUtm) => {
      return dispatch(policyActions.finalisePolicy(id, policy, utm));
    },
    clear: () => dispatch(paymentActions.clearPaymentResponse())
  };
};

export const Checkout = connect(mapStateToProps, mapDispatchToProps)(_Checkout);
